import {
  PLAYER_MODALS_Z_INDEX_DECREASE,
  PLAYER_MODALS_Z_INDEX_INCREASE,
  PLAYER_OPTIONS_HIDE_GRID,
  PLAYER_OPTIONS_SHOW_GRID,
} from './constants';

export const showGrid = () => dispatch => {
  dispatch({
    type: PLAYER_MODALS_Z_INDEX_INCREASE,
  });
  dispatch({
    type: PLAYER_OPTIONS_SHOW_GRID,
  });
};

export const hideGrid = () => (dispatch, getState) => {
  const state = getState();
  if (state.Player.OptionButtons.grid.isOpen) {
    dispatch({
      type: PLAYER_MODALS_Z_INDEX_DECREASE,
    });
    dispatch({
      type: PLAYER_OPTIONS_HIDE_GRID,
    });
  }
};
